// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Log$SmartcutsMacros = require("./Log.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Image$SmartcutsMacros = require("./Image.bs.js");
var Command$SmartcutsMacros = require("./Command.bs.js");
var ImageKit$SmartcutsMacros = require("./bindings/ImageKit.bs.js");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var CommandLog$SmartcutsMacros = require("./CommandLog.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../bs-utils/src/DeccoUtils.bs.js");
var Exceptions$SmartcutsMacros = require("./Exceptions.bs.js");
var Screenshot$SmartcutsMacros = require("./Screenshot.bs.js");
var LoopCommand$SmartcutsMacros = require("./commands/LoopCommand.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("./SmartcutIds.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var TypeCommand$SmartcutsMacros = require("./commands/TypeCommand.bs.js");
var PromiseUtils$SmartcutsMacros = require("../../bs-utils/src/PromiseUtils.bs.js");
var RadioCommand$SmartcutsMacros = require("./commands/RadioCommand.bs.js");
var LoginSmartcut$SmartcutsMacros = require("./LoginSmartcut.bs.js");
var SelectCommand$SmartcutsMacros = require("./commands/SelectCommand.bs.js");
var UploadCommand$SmartcutsMacros = require("./commands/UploadCommand.bs.js");
var UrlConstraint$SmartcutsMacros = require("./UrlConstraint.bs.js");
var UrlLevenshtein$SmartcutsMacros = require("./UrlLevenshtein.bs.js");
var CheckboxCommand$SmartcutsMacros = require("./commands/CheckboxCommand.bs.js");
var DownloadCommand$SmartcutsMacros = require("./commands/DownloadCommand.bs.js");
var PlaybackOptions$SmartcutsMacros = require("./PlaybackOptions.bs.js");
var URLRelatedCommands$SmartcutsMacros = require("./commands/shared/URLRelatedCommands.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("./commands/GoogleSheetsCommand.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./commands/WithElementGroupsCommand.bs.js");
var CommandValueConfigurability$SmartcutsMacros = require("./CommandValueConfigurability.bs.js");
var InnerTextSemanticParamDescriptor$SmartcutsMacros = require("./semantics/InnerTextSemanticParamDescriptor.bs.js");

function param_encode(v) {
  switch (v.TAG | 0) {
    case /* AddTextInputParam */0 :
        return [
                "AddTextInputParam",
                Curry._1(TypeCommand$SmartcutsMacros.ParamDescriptor.AddTextInputParam.t_encode, v._0)
              ];
    case /* InnerTextParam */1 :
        return [
                "InnerTextParam",
                InnerTextSemanticParamDescriptor$SmartcutsMacros.t_encode(v._0)
              ];
    case /* CheckboxParam */2 :
        return [
                "CheckboxParam",
                CheckboxCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
              ];
    case /* SelectInputParam */3 :
        return [
                "SelectInputParam",
                SelectCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
              ];
    case /* RadioInputParam */4 :
        return [
                "RadioInputParam",
                RadioCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
              ];
    case /* URLParam */5 :
        return [
                "URLParam",
                URLRelatedCommands$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
              ];
    case /* DownloadParam */6 :
        return [
                "DownloadParam",
                DownloadCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
              ];
    case /* GoogleSheetsParam */7 :
        return [
                "GoogleSheetsParam",
                GoogleSheetsCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
              ];
    case /* LoopParam */8 :
        return [
                "LoopParam",
                LoopCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
              ];
    case /* UploadParam */9 :
        return [
                "UploadParam",
                UploadCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
              ];
    case /* WithElementGroupsParam */10 :
        return [
                "WithElementGroupsParam",
                WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.t_encode(v._0)
              ];
    
  }
}

function param_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AddTextInputParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(TypeCommand$SmartcutsMacros.ParamDescriptor.AddTextInputParam.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AddTextInputParam */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "CheckboxParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = CheckboxCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CheckboxParam */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "DownloadParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = DownloadCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DownloadParam */6,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "GoogleSheetsParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = GoogleSheetsCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* GoogleSheetsParam */7,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "InnerTextParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = InnerTextSemanticParamDescriptor$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InnerTextParam */1,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "LoopParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = LoopCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* LoopParam */8,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "RadioInputParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = RadioCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RadioInputParam */4,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "SelectInputParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = SelectCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectInputParam */3,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "URLParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = URLRelatedCommands$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* URLParam */5,
                      _0: v0$8._0
                    }
                  };
          }
          var e$8 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "UploadParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = UploadCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UploadParam */9,
                      _0: v0$9._0
                    }
                  };
          }
          var e$9 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "WithElementGroupsParam" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* WithElementGroupsParam */10,
                      _0: v0$10._0
                    }
                  };
          }
          var e$10 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function getPlaybackFormLabelFromParam(param) {
  switch (param.TAG | 0) {
    case /* InnerTextParam */1 :
        return InnerTextSemanticParamDescriptor$SmartcutsMacros.getPlaybackFormLabelFromParam(param._0);
    case /* CheckboxParam */2 :
        return param._0.playbackFormLabel;
    case /* DownloadParam */6 :
        return DownloadCommand$SmartcutsMacros.ParamDescriptor.getPlaybackFormLabelFromParam(param._0);
    case /* GoogleSheetsParam */7 :
        return GoogleSheetsCommand$SmartcutsMacros.ParamDescriptor.getPlaybackFormLabelFromParam(param._0);
    case /* URLParam */5 :
    case /* LoopParam */8 :
        return ;
    case /* UploadParam */9 :
        return UploadCommand$SmartcutsMacros.ParamDescriptor.getPlaybackFormLabelFromParam(param._0);
    case /* WithElementGroupsParam */10 :
        return WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.getPlaybackFormLabelFromParam(param._0);
    default:
      return param._0.playbackFormLabel;
  }
}

function minifyParam(param) {
  return param;
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "firstCommandIndex",
                Decco.intToJson(v.firstCommandIndex)
              ],
              [
                "otherCommandIndexes",
                Decco.listToJson(Decco.intToJson, v.otherCommandIndexes)
              ],
              [
                "param",
                param_encode(v.param)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var firstCommandIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstCommandIndex"), null));
  if (firstCommandIndex.TAG === /* Ok */0) {
    var otherCommandIndexes = Decco.listFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "otherCommandIndexes"), null));
    if (otherCommandIndexes.TAG === /* Ok */0) {
      var param = param_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "param"), null));
      if (param.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  firstCommandIndex: firstCommandIndex._0,
                  otherCommandIndexes: otherCommandIndexes._0,
                  param: param._0
                }
              };
      }
      var e = param._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".param" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = otherCommandIndexes._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".otherCommandIndexes" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = firstCommandIndex._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".firstCommandIndex" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function toGraphql(param) {
  return {
          firstCommandIndex: param.firstCommandIndex,
          otherCommandIndexes: $$Array.of_list(param.otherCommandIndexes),
          param: JSON.stringify(param_encode(param.param))
        };
}

function minify(param) {
  return {
          firstCommandIndex: param.firstCommandIndex,
          otherCommandIndexes: param.otherCommandIndexes,
          param: param.param
        };
}

function removePrivateInfo(paramDescriptor) {
  var param = paramDescriptor.param;
  var param$1;
  switch (param.TAG | 0) {
    case /* AddTextInputParam */0 :
        var match = param._0;
        var enums = match.enums;
        var match$1 = match.originalLabeledAddText;
        var addText = match$1.addText;
        var match$2 = Belt_Option.flatMap(enums, (function ($$enum) {
                return Belt_Array.get($$enum, 0);
              }));
        var tmp;
        tmp = addText.TAG === /* StaticText */0 ? (
            match$2 !== undefined ? ({
                  TAG: /* StaticText */0,
                  _0: match$2
                }) : ({
                  TAG: /* StaticText */0,
                  _0: "Please insert text here"
                })
          ) : addText;
        param$1 = {
          TAG: /* AddTextInputParam */0,
          _0: {
            targetLocator: match.targetLocator,
            originalLabeledAddText: {
              label: match$1.label,
              addText: tmp
            },
            playbackFormLabel: match.playbackFormLabel,
            enums: enums
          }
        };
        break;
    case /* InnerTextParam */1 :
        param$1 = {
          TAG: /* InnerTextParam */1,
          _0: InnerTextSemanticParamDescriptor$SmartcutsMacros.removePrivateInfo(param._0)
        };
        break;
    case /* CheckboxParam */2 :
        var match$3 = param._0;
        var match$4 = match$3.originalCheckboxChoice;
        if (match$4.TAG === /* SingleCheckbox */0) {
          param$1 = {
            TAG: /* CheckboxParam */2,
            _0: {
              originalCheckboxChoice: {
                TAG: /* SingleCheckbox */0,
                _0: match$4._0,
                _1: false
              },
              playbackFormLabel: match$3.playbackFormLabel
            }
          };
        } else {
          var match$5 = match$4._0;
          param$1 = {
            TAG: /* CheckboxParam */2,
            _0: {
              originalCheckboxChoice: {
                TAG: /* CheckboxGroup */1,
                _0: {
                  name: match$5.name,
                  checkedValues: /* [] */0,
                  options: match$5.options
                }
              },
              playbackFormLabel: match$3.playbackFormLabel
            }
          };
        }
        break;
    case /* SelectInputParam */3 :
        var match$6 = param._0;
        var match$7 = match$6.originalLabeledValue;
        var match$8 = match$7.value;
        param$1 = {
          TAG: /* SelectInputParam */3,
          _0: {
            targetLocator: match$6.targetLocator,
            originalLabeledValue: {
              label: match$7.label,
              value: {
                options: match$8.options,
                selectedIndex: match$8.selectedIndex
              }
            },
            playbackFormLabel: match$6.playbackFormLabel
          }
        };
        break;
    case /* RadioInputParam */4 :
        var match$9 = param._0;
        var match$10 = match$9.originalLabeledValue;
        param$1 = {
          TAG: /* RadioInputParam */4,
          _0: {
            targetLocator: match$9.targetLocator,
            originalLabeledValue: {
              label: match$10.label,
              value: match$10.value
            },
            playbackFormLabel: match$9.playbackFormLabel
          }
        };
        break;
    case /* DownloadParam */6 :
        param$1 = {
          TAG: /* DownloadParam */6,
          _0: DownloadCommand$SmartcutsMacros.ParamDescriptor.removePrivateInfo(param._0)
        };
        break;
    case /* GoogleSheetsParam */7 :
        var match$11 = param._0;
        if (match$11.TAG === /* UpdateCellParam */0) {
          var match$12 = match$11._0;
          param$1 = {
            TAG: /* GoogleSheetsParam */7,
            _0: {
              TAG: /* UpdateCellParam */0,
              _0: {
                spreadsheetId: "Insert sheet id here",
                sheetName: "Insert sheet name here",
                colNames: match$12.colNames,
                keyColumnIndex: match$12.keyColumnIndex,
                keyColumnValue: match$12.keyColumnValue,
                updatedColIndex: match$12.updatedColIndex,
                cellUpdate: match$12.cellUpdate,
                playbackFormLabel: match$12.playbackFormLabel
              }
            }
          };
        } else {
          var match$13 = match$11._0;
          param$1 = {
            TAG: /* GoogleSheetsParam */7,
            _0: {
              TAG: /* UpsertRowParam */1,
              _0: {
                spreadsheetId: "Insert sheet id here",
                sheetName: "Insert sheet name here",
                colNames: match$13.colNames,
                keyColumnIndex: match$13.keyColumnIndex,
                keyColumnValue: match$13.keyColumnValue,
                rowData: match$13.rowData,
                playbackFormLabel: match$13.playbackFormLabel
              }
            }
          };
        }
        break;
    case /* URLParam */5 :
    case /* LoopParam */8 :
        param$1 = param;
        break;
    case /* UploadParam */9 :
        param$1 = {
          TAG: /* UploadParam */9,
          _0: param._0
        };
        break;
    case /* WithElementGroupsParam */10 :
        param$1 = {
          TAG: /* WithElementGroupsParam */10,
          _0: WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.removePrivateInfo(param._0)
        };
        break;
    
  }
  return {
          firstCommandIndex: paramDescriptor.firstCommandIndex,
          otherCommandIndexes: paramDescriptor.otherCommandIndexes,
          param: param$1
        };
}

function maybeFromCommandValueConfigurability(param) {
  var config = param.config;
  var otherCommandIndexes = param.otherCommandIndexes;
  var firstCommandIndex = param.firstCommandIndex;
  var maybeParam;
  switch (config.TAG | 0) {
    case /* AddTextInputConfig */0 :
        maybeParam = {
          TAG: /* AddTextInputParam */0,
          _0: Curry._1(TypeCommand$SmartcutsMacros.ParamDescriptor.AddTextInputParam.fromAuthoringConfig, config._0)
        };
        break;
    case /* InnerTextConfig */2 :
        maybeParam = OptionUtils$SmartcutsMacros.map(InnerTextSemanticParamDescriptor$SmartcutsMacros.fromAuthoringConfig(config._0), (function (paramDescriptor) {
                return {
                        TAG: /* InnerTextParam */1,
                        _0: paramDescriptor
                      };
              }));
        break;
    case /* CheckboxConfig */3 :
        maybeParam = {
          TAG: /* CheckboxParam */2,
          _0: CheckboxCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
        };
        break;
    case /* SelectInputConfig */4 :
        maybeParam = {
          TAG: /* SelectInputParam */3,
          _0: SelectCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
        };
        break;
    case /* RadioInputConfig */5 :
        maybeParam = {
          TAG: /* RadioInputParam */4,
          _0: RadioCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
        };
        break;
    case /* URLConfig */6 :
        maybeParam = {
          TAG: /* URLParam */5,
          _0: URLRelatedCommands$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
        };
        break;
    case /* DownloadConfig */12 :
        maybeParam = {
          TAG: /* DownloadParam */6,
          _0: DownloadCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0)
        };
        break;
    case /* GoogleSheetsConfig */13 :
        var param$1 = GoogleSheetsCommand$SmartcutsMacros.ParamDescriptor.fromCommandValueConfigurability(config._0);
        maybeParam = {
          TAG: /* GoogleSheetsParam */7,
          _0: param$1
        };
        break;
    case /* LoopConfig */16 :
        var param$2 = LoopCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0);
        maybeParam = {
          TAG: /* LoopParam */8,
          _0: param$2
        };
        break;
    case /* UploadConfig */17 :
        var param$3 = UploadCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0);
        maybeParam = {
          TAG: /* UploadParam */9,
          _0: param$3
        };
        break;
    case /* WithElementGroupsConfig */18 :
        var param$4 = WithElementGroupsCommand$SmartcutsMacros.ParamDescriptor.fromAuthoringConfig(config._0);
        maybeParam = {
          TAG: /* WithElementGroupsParam */10,
          _0: param$4
        };
        break;
    default:
      maybeParam = undefined;
  }
  return OptionUtils$SmartcutsMacros.map(maybeParam, (function (param) {
                return {
                        firstCommandIndex: firstCommandIndex,
                        otherCommandIndexes: otherCommandIndexes,
                        param: param
                      };
              }));
}

function arrayFromCommandValueConfigurabilities(commandValueConfigurabilities) {
  return Belt_Array.keepMap(Belt_Array.keep(commandValueConfigurabilities, CommandValueConfigurability$SmartcutsMacros.isDynamic), maybeFromCommandValueConfigurability);
}

var ParamDescriptor = {
  param_encode: param_encode,
  param_decode: param_decode,
  getPlaybackFormLabelFromParam: getPlaybackFormLabelFromParam,
  minifyParam: minifyParam,
  t_encode: t_encode,
  t_decode: t_decode,
  toGraphql: toGraphql,
  minify: minify,
  removePrivateInfo: removePrivateInfo,
  maybeFromCommandValueConfigurability: maybeFromCommandValueConfigurability,
  arrayFromCommandValueConfigurabilities: arrayFromCommandValueConfigurabilities
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "description",
                Decco.optionToJson(Decco.stringToJson, v.description)
              ],
              [
                "authoringCommandLog",
                CommandLog$SmartcutsMacros.GlobalForAuthoring.t_encode(v.authoringCommandLog)
              ],
              [
                "commandLog",
                CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode(v.commandLog)
              ],
              [
                "smartcutParams",
                Decco.arrayToJson(t_encode, v.smartcutParams)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        var authoringCommandLog = CommandLog$SmartcutsMacros.GlobalForAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "authoringCommandLog"), null));
        if (authoringCommandLog.TAG === /* Ok */0) {
          var commandLog = CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLog"), null));
          if (commandLog.TAG === /* Ok */0) {
            var smartcutParams = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutParams"), null));
            if (smartcutParams.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        id: id._0,
                        name: name._0,
                        description: description._0,
                        authoringCommandLog: authoringCommandLog._0,
                        commandLog: commandLog._0,
                        smartcutParams: smartcutParams._0
                      }
                    };
            }
            var e = smartcutParams._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".smartcutParams" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = commandLog._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".commandLog" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = authoringCommandLog._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".authoringCommandLog" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function minify$1(smartcut) {
  return {
          id: smartcut.id,
          name: smartcut.name,
          description: smartcut.description,
          authoringCommandLog: List.map(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.minify, smartcut.authoringCommandLog),
          commandLog: List.map(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.minify, smartcut.commandLog),
          smartcutParams: smartcut.smartcutParams
        };
}

var ForAuthoringSubmission = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  minify: minify$1
};

var SavedSmartcut = {};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "id",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.id)
              ],
              [
                "maybeDefaultPlaybackOptions",
                Decco.optionToJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_encode, v.maybeDefaultPlaybackOptions)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var maybeDefaultPlaybackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeDefaultPlaybackOptions"), null));
    if (maybeDefaultPlaybackOptions.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                id: id._0,
                maybeDefaultPlaybackOptions: maybeDefaultPlaybackOptions._0
              }
            };
    }
    var e = maybeDefaultPlaybackOptions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".maybeDefaultPlaybackOptions" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

var InstalledSmartcut = {
  t_encode: t_encode$2,
  t_decode: t_decode$2
};

function t_encode$3(v) {
  switch (v) {
    case /* PRIVATE */0 :
        return ["PRIVATE"];
    case /* PUBLIC */1 :
        return ["PUBLIC"];
    case /* UNLISTED */2 :
        return ["UNLISTED"];
    
  }
}

function t_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "PRIVATE" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PRIVATE */0
                  };
          }
      case "PUBLIC" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PUBLIC */1
                  };
          }
      case "UNLISTED" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UNLISTED */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function fromVariant(variant) {
  if (variant === "PRIVATE") {
    return /* PRIVATE */0;
  } else if (variant === "PUBLIC") {
    return /* PUBLIC */1;
  } else {
    return /* UNLISTED */2;
  }
}

function stringify(v) {
  switch (v) {
    case /* PRIVATE */0 :
        return "PRIVATE";
    case /* PUBLIC */1 :
        return "PUBLIC";
    case /* UNLISTED */2 :
        return "UNLISTED";
    
  }
}

var SmartcutVisibility = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromVariant: fromVariant,
  stringify: stringify
};

function t_encode$4(v) {
  return Js_dict.fromArray([
              [
                "id",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.id)
              ],
              [
                "visibility",
                t_encode$3(v.visibility)
              ],
              [
                "stepDescriptions",
                Decco.arrayToJson(Decco.stringToJson, v.stepDescriptions)
              ],
              [
                "msBeforeNextCommand",
                Decco.arrayToJson(Decco.intToJson, v.msBeforeNextCommand)
              ],
              [
                "maybeMsBeforeCloseWindow",
                Decco.optionToJson(Decco.intToJson, v.maybeMsBeforeCloseWindow)
              ],
              [
                "loginUrls",
                Decco.arrayToJson(Decco.stringToJson, v.loginUrls)
              ],
              [
                "maybeDefaultPlaybackOptions",
                Decco.optionToJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_encode, v.maybeDefaultPlaybackOptions)
              ],
              [
                "loginSmartcuts",
                Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.t__encode, v.loginSmartcuts)
              ]
            ]);
}

function t_decode$4(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var visibility = t_decode$3(Belt_Option.getWithDefault(Js_dict.get(dict$1, "visibility"), null));
    if (visibility.TAG === /* Ok */0) {
      var stepDescriptions = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "stepDescriptions"), null));
      if (stepDescriptions.TAG === /* Ok */0) {
        var msBeforeNextCommand = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "msBeforeNextCommand"), null));
        if (msBeforeNextCommand.TAG === /* Ok */0) {
          var maybeMsBeforeCloseWindow = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeMsBeforeCloseWindow"), null));
          if (maybeMsBeforeCloseWindow.TAG === /* Ok */0) {
            var loginUrls = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginUrls"), null));
            if (loginUrls.TAG === /* Ok */0) {
              var maybeDefaultPlaybackOptions = Decco.optionFromJson(PlaybackOptions$SmartcutsMacros.SmartcutDefaultPlaybackOptions.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeDefaultPlaybackOptions"), null));
              if (maybeDefaultPlaybackOptions.TAG === /* Ok */0) {
                var loginSmartcuts = Curry._1(LoginSmartcut$SmartcutsMacros.ByHostnameAndScenario.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginSmartcuts"), null));
                if (loginSmartcuts.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            id: id._0,
                            visibility: visibility._0,
                            stepDescriptions: stepDescriptions._0,
                            msBeforeNextCommand: msBeforeNextCommand._0,
                            maybeMsBeforeCloseWindow: maybeMsBeforeCloseWindow._0,
                            loginUrls: loginUrls._0,
                            maybeDefaultPlaybackOptions: maybeDefaultPlaybackOptions._0,
                            loginSmartcuts: loginSmartcuts._0
                          }
                        };
                }
                var e = loginSmartcuts._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".loginSmartcuts" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = maybeDefaultPlaybackOptions._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".maybeDefaultPlaybackOptions" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = loginUrls._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".loginUrls" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = maybeMsBeforeCloseWindow._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".maybeMsBeforeCloseWindow" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = msBeforeNextCommand._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".msBeforeNextCommand" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = stepDescriptions._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".stepDescriptions" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = visibility._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".visibility" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

var Smartcut = {
  t_encode: t_encode$4,
  t_decode: t_decode$4
};

function t_encode$5(v) {
  return Js_dict.fromArray([
              [
                "id",
                SmartcutIds$SmartcutsMacros.recordedSmartcutId_encode(v.id)
              ],
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "description",
                Decco.optionToJson(Decco.stringToJson, v.description)
              ],
              [
                "startingUrlPattern",
                Decco.optionToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v.startingUrlPattern)
              ],
              [
                "maybeRedirectedFromUrlPatterns",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, param);
                      }), v.maybeRedirectedFromUrlPatterns)
              ],
              [
                "origins",
                Decco.arrayToJson(Decco.stringToJson, v.origins)
              ],
              [
                "schemaVersion",
                Decco.stringToJson(v.schemaVersion)
              ],
              [
                "numCommands",
                Decco.intToJson(v.numCommands)
              ],
              [
                "commandLogData",
                DeccoUtils$SmartcutsMacros.decodable_encode(CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode, v.commandLogData)
              ],
              [
                "smartcutParamsData",
                DeccoUtils$SmartcutsMacros.decodable_encode((function (param) {
                        return Decco.arrayToJson(t_encode, param);
                      }), v.smartcutParamsData)
              ],
              [
                "installedSmartcut",
                t_encode$2(v.installedSmartcut)
              ],
              [
                "smartcut",
                t_encode$4(v.smartcut)
              ]
            ]);
}

function t_decode$5(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = SmartcutIds$SmartcutsMacros.recordedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        var startingUrlPattern = Decco.optionFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startingUrlPattern"), null));
        if (startingUrlPattern.TAG === /* Ok */0) {
          var maybeRedirectedFromUrlPatterns = Decco.optionFromJson((function (param) {
                  return Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, param);
                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeRedirectedFromUrlPatterns"), null));
          if (maybeRedirectedFromUrlPatterns.TAG === /* Ok */0) {
            var origins = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "origins"), null));
            if (origins.TAG === /* Ok */0) {
              var schemaVersion = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "schemaVersion"), null));
              if (schemaVersion.TAG === /* Ok */0) {
                var numCommands = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numCommands"), null));
                if (numCommands.TAG === /* Ok */0) {
                  var commandLogData = DeccoUtils$SmartcutsMacros.decodable_decode(CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLogData"), null));
                  if (commandLogData.TAG === /* Ok */0) {
                    var smartcutParamsData = DeccoUtils$SmartcutsMacros.decodable_decode((function (param) {
                            return Decco.arrayFromJson(t_decode, param);
                          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutParamsData"), null));
                    if (smartcutParamsData.TAG === /* Ok */0) {
                      var installedSmartcut = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcut"), null));
                      if (installedSmartcut.TAG === /* Ok */0) {
                        var smartcut = t_decode$4(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcut"), null));
                        if (smartcut.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    id: id._0,
                                    name: name._0,
                                    description: description._0,
                                    startingUrlPattern: startingUrlPattern._0,
                                    maybeRedirectedFromUrlPatterns: maybeRedirectedFromUrlPatterns._0,
                                    origins: origins._0,
                                    schemaVersion: schemaVersion._0,
                                    numCommands: numCommands._0,
                                    commandLogData: commandLogData._0,
                                    smartcutParamsData: smartcutParamsData._0,
                                    installedSmartcut: installedSmartcut._0,
                                    smartcut: smartcut._0
                                  }
                                };
                        }
                        var e = smartcut._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".smartcut" + e.path,
                                  message: e.message,
                                  value: e.value
                                }
                              };
                      }
                      var e$1 = installedSmartcut._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".installedSmartcut" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                              }
                            };
                    }
                    var e$2 = smartcutParamsData._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".smartcutParamsData" + e$2.path,
                              message: e$2.message,
                              value: e$2.value
                            }
                          };
                  }
                  var e$3 = commandLogData._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".commandLogData" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                          }
                        };
                }
                var e$4 = numCommands._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".numCommands" + e$4.path,
                          message: e$4.message,
                          value: e$4.value
                        }
                      };
              }
              var e$5 = schemaVersion._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".schemaVersion" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                      }
                    };
            }
            var e$6 = origins._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".origins" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = maybeRedirectedFromUrlPatterns._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".maybeRedirectedFromUrlPatterns" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
        }
        var e$8 = startingUrlPattern._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".startingUrlPattern" + e$8.path,
                  message: e$8.message,
                  value: e$8.value
                }
              };
      }
      var e$9 = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e$9.path,
                message: e$9.message,
                value: e$9.value
              }
            };
    }
    var e$10 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$10.path,
              message: e$10.message,
              value: e$10.value
            }
          };
  }
  var e$11 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$11.path,
            message: e$11.message,
            value: e$11.value
          }
        };
}

function minify$2(smartcut) {
  var commandLogData = smartcut.commandLogData;
  var tmp;
  tmp = commandLogData.TAG === /* Decoded */0 ? ({
        TAG: /* Decoded */0,
        _0: List.map(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.minify, commandLogData._0)
      }) : ({
        TAG: /* UnableToDecode */1,
        _0: null
      });
  return {
          id: smartcut.id,
          name: smartcut.name,
          description: smartcut.description,
          startingUrlPattern: smartcut.startingUrlPattern,
          maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
          origins: smartcut.origins,
          schemaVersion: smartcut.schemaVersion,
          numCommands: smartcut.numCommands,
          commandLogData: tmp,
          smartcutParamsData: smartcut.smartcutParamsData,
          installedSmartcut: smartcut.installedSmartcut,
          smartcut: smartcut.smartcut
        };
}

function rehydrate(smartcut) {
  var commandLogData = smartcut.commandLogData;
  if (commandLogData.TAG === /* Decoded */0) {
    return CommandLog$SmartcutsMacros.GlobalForPlayback.rehydrate(commandLogData._0).then(function (rehydratedCommandLog) {
                return Promise.resolve({
                            id: smartcut.id,
                            name: smartcut.name,
                            description: smartcut.description,
                            startingUrlPattern: smartcut.startingUrlPattern,
                            maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
                            origins: smartcut.origins,
                            schemaVersion: smartcut.schemaVersion,
                            numCommands: smartcut.numCommands,
                            commandLogData: {
                              TAG: /* Decoded */0,
                              _0: rehydratedCommandLog
                            },
                            smartcutParamsData: smartcut.smartcutParamsData,
                            installedSmartcut: smartcut.installedSmartcut,
                            smartcut: smartcut.smartcut
                          });
              });
  } else {
    return Promise.resolve(smartcut);
  }
}

function getStartingUrl(param) {
  var smartcutParamsData = param.smartcutParamsData;
  var commandLogData = param.commandLogData;
  var maybeParamForFirstCommand;
  maybeParamForFirstCommand = smartcutParamsData.TAG === /* Decoded */0 ? Belt_Array.getBy(smartcutParamsData._0, (function (param) {
            return param.firstCommandIndex === 0;
          })) : undefined;
  if (maybeParamForFirstCommand !== undefined) {
    var match = maybeParamForFirstCommand.param;
    if (match.TAG === /* URLParam */5) {
      return URLUtils$SmartcutsMacros.$$URL.fromString(match._0.originalUrl);
    } else {
      return ;
    }
  }
  if (commandLogData.TAG !== /* Decoded */0) {
    return ;
  }
  var match$1 = commandLogData._0;
  if (!match$1) {
    return ;
  }
  var match$2 = match$1.hd.command;
  if (typeof match$2 === "number" || match$2.TAG !== /* NewWindowWithUrlCommand */1) {
    return ;
  } else {
    return URLUtils$SmartcutsMacros.$$URL.fromString(match$2._0.url);
  }
}

function getStartingUrlExn(param) {
  var smartcutParamsData = param.smartcutParamsData;
  var commandLogData = param.commandLogData;
  var origins = param.origins;
  var maybeParamForFirstCommand;
  maybeParamForFirstCommand = smartcutParamsData.TAG === /* Decoded */0 ? Belt_Array.getBy(smartcutParamsData._0, (function (param) {
            return param.firstCommandIndex === 0;
          })) : undefined;
  if (maybeParamForFirstCommand !== undefined) {
    var match = maybeParamForFirstCommand.param;
    if (match.TAG !== /* URLParam */5) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected param associated with first command to be a URLParam");
    }
    var originalUrl = match._0.originalUrl;
    var urlRecord = URLUtils$SmartcutsMacros.$$URL.fromString(originalUrl);
    if (urlRecord !== undefined) {
      return urlRecord;
    }
    throw {
          RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
          _1: originalUrl,
          Error: new Error()
        };
  }
  if (commandLogData.TAG === /* Decoded */0) {
    var match$1 = commandLogData._0;
    if (!match$1) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected command log to be non-empty");
    }
    var match$2 = match$1.hd.command;
    if (typeof match$2 === "number") {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected first command of command log to be NewWindowWithUrlCommand(url, focusState)");
    }
    if (match$2.TAG !== /* NewWindowWithUrlCommand */1) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected first command of command log to be NewWindowWithUrlCommand(url, focusState)");
    }
    var url = match$2._0.url;
    var urlRecord$1 = URLUtils$SmartcutsMacros.$$URL.fromString(url);
    if (urlRecord$1 !== undefined) {
      return urlRecord$1;
    }
    throw {
          RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
          _1: url,
          Error: new Error()
        };
  } else {
    var urlRecord$2 = URLUtils$SmartcutsMacros.$$URL.fromString(Caml_array.get(origins, 0));
    if (urlRecord$2 !== undefined) {
      return urlRecord$2;
    }
    throw {
          RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
          _1: Caml_array.get(origins, 0),
          Error: new Error()
        };
  }
}

function getNumParams(param) {
  var smartcutParamsData = param.smartcutParamsData;
  if (smartcutParamsData.TAG === /* Decoded */0) {
    return smartcutParamsData._0.length;
  } else {
    return OptionUtils$SmartcutsMacros.withDefault(-1, OptionUtils$SmartcutsMacros.map(Js_json.decodeArray(smartcutParamsData._0), (function (prim) {
                      return prim.length;
                    })));
  }
}

function updateScreenshot(f, smartcut) {
  var commandLogData = smartcut.commandLogData;
  var tmp;
  tmp = commandLogData.TAG === /* Decoded */0 ? ({
        TAG: /* Decoded */0,
        _0: List.map((function (commandWithContextGlobal) {
                var contextGlobal = commandWithContextGlobal.contextGlobal;
                return {
                        id: commandWithContextGlobal.id,
                        command: commandWithContextGlobal.command,
                        contextGlobal: {
                          windowRef: contextGlobal.windowRef,
                          tabRef: contextGlobal.tabRef,
                          url: contextGlobal.url,
                          focusStatus: contextGlobal.focusStatus,
                          title: contextGlobal.title,
                          frame: contextGlobal.frame,
                          windowGeometry: contextGlobal.windowGeometry,
                          targetBoundingRect: contextGlobal.targetBoundingRect,
                          timestamp: contextGlobal.timestamp,
                          htmlSnapshot: contextGlobal.htmlSnapshot,
                          screenshot: Curry._1(f, contextGlobal.screenshot),
                          croppedScreenshot: Curry._1(f, contextGlobal.croppedScreenshot),
                          preconditions: contextGlobal.preconditions,
                          maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                        }
                      };
              }), commandLogData._0)
      }) : commandLogData;
  return {
          id: smartcut.id,
          name: smartcut.name,
          description: smartcut.description,
          startingUrlPattern: smartcut.startingUrlPattern,
          maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
          origins: smartcut.origins,
          schemaVersion: smartcut.schemaVersion,
          numCommands: smartcut.numCommands,
          commandLogData: tmp,
          smartcutParamsData: smartcut.smartcutParamsData,
          installedSmartcut: smartcut.installedSmartcut,
          smartcut: smartcut.smartcut
        };
}

function startingAndRedirectedFromUrlPatterns(param) {
  return Belt_Array.concat(OptionUtils$SmartcutsMacros.toArray(param.startingUrlPattern), OptionUtils$SmartcutsMacros.withDefault([], param.maybeRedirectedFromUrlPatterns));
}

function doesMatchUrl(url, smartcut) {
  return Belt_Array.some(startingAndRedirectedFromUrlPatterns(smartcut), (function (param) {
                return UrlConstraint$SmartcutsMacros.UrlPattern.doesMatchUrl(url, param);
              }));
}

function determineRunFromPageCapability(maybePageUrl, smartcut) {
  var match = smartcut.commandLogData;
  if (match.TAG === /* Decoded */0 && maybePageUrl !== undefined && doesMatchUrl(maybePageUrl, smartcut)) {
    return /* CanRunFromPage */1;
  } else {
    return /* CannotRunFromPage */0;
  }
}

function makeComparator(targetUrl, aSmartcut, bSmartcut) {
  var match = aSmartcut.commandLogData;
  var match$1 = bSmartcut.commandLogData;
  var match$2 = getStartingUrlExn(aSmartcut);
  var match$3 = getStartingUrlExn(bSmartcut);
  var exit = 0;
  var url;
  var urlA;
  var urlB;
  if (match.TAG === /* Decoded */0) {
    if (match$1.TAG !== /* Decoded */0) {
      return -1;
    }
    if (targetUrl === undefined) {
      return 0;
    }
    url = targetUrl;
    urlA = match$2;
    urlB = match$3;
    exit = 1;
  } else {
    if (match$1.TAG === /* Decoded */0) {
      return 1;
    }
    if (targetUrl === undefined) {
      return 0;
    }
    url = targetUrl;
    urlA = match$2;
    urlB = match$3;
    exit = 1;
  }
  if (exit === 1) {
    var sharesTargetHostname = function (param) {
      return URLUtils$SmartcutsMacros.$$URL.sharesHostname(true, url, param);
    };
    var match$4 = sharesTargetHostname(urlA) && urlA.protocol === url.protocol && urlA.port === url.port && URLUtils$SmartcutsMacros.$$URL.numPathComponents(urlA) === URLUtils$SmartcutsMacros.$$URL.numPathComponents(url);
    var match$5 = sharesTargetHostname(urlB) && urlB.protocol === url.protocol && urlB.port === url.port && URLUtils$SmartcutsMacros.$$URL.numPathComponents(urlB) === URLUtils$SmartcutsMacros.$$URL.numPathComponents(url);
    if (match$4) {
      if (!match$5) {
        return -1;
      }
      var levUrl = UrlLevenshtein$SmartcutsMacros.Url.fromString(url.toString());
      var levUrl$1;
      if (levUrl !== undefined) {
        levUrl$1 = levUrl;
      } else {
        throw {
              RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
              _1: url.toString(),
              Error: new Error()
            };
      }
      var levUrlA = UrlLevenshtein$SmartcutsMacros.Url.fromString(urlA.toString());
      var levUrlA$1;
      if (levUrlA !== undefined) {
        levUrlA$1 = levUrlA;
      } else {
        throw {
              RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
              _1: urlA.toString(),
              Error: new Error()
            };
      }
      var levUrlB = UrlLevenshtein$SmartcutsMacros.Url.fromString(urlB.toString());
      var levUrlB$1;
      if (levUrlB !== undefined) {
        levUrlB$1 = levUrlB;
      } else {
        throw {
              RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
              _1: urlB.toString(),
              Error: new Error()
            };
      }
      return UrlLevenshtein$SmartcutsMacros.calcLevenshteinDistance(levUrl$1, levUrlA$1) - UrlLevenshtein$SmartcutsMacros.calcLevenshteinDistance(levUrl$1, levUrlB$1) | 0;
    }
    if (match$5) {
      return 1;
    }
    var arg = startingAndRedirectedFromUrlPatterns(aSmartcut);
    var match$6 = (function (param) {
          return ArrayUtils$SmartcutsMacros.firstMatch(param, arg);
        })(function (urlPattern) {
          return UrlConstraint$SmartcutsMacros.UrlPattern.doesMatchUrl(url, urlPattern);
        });
    var arg$1 = startingAndRedirectedFromUrlPatterns(bSmartcut);
    var match$7 = (function (param) {
          return ArrayUtils$SmartcutsMacros.firstMatch(param, arg$1);
        })(function (urlPattern) {
          return UrlConstraint$SmartcutsMacros.UrlPattern.doesMatchUrl(url, urlPattern);
        });
    var exit$1 = 0;
    if (match$6 !== undefined) {
      if (match$7 === undefined) {
        return -1;
      }
      exit$1 = 2;
    } else {
      if (match$7 !== undefined) {
        return 1;
      }
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      if (URLUtils$SmartcutsMacros.$$URL.sharesHostname(true, urlA, urlB)) {
        return 0;
      }
      var match$8 = sharesTargetHostname(urlA);
      var match$9 = sharesTargetHostname(urlB);
      if (match$8) {
        if (match$9) {
          return urlA.toString().localeCompare(urlB.toString()) | 0;
        } else {
          return -1;
        }
      } else if (match$9) {
        return 1;
      } else {
        return urlA.toString().localeCompare(urlB.toString()) | 0;
      }
    }
    
  }
  
}

var RelativeToUrlWithOutdatedSmartcutsLast = {
  makeComparator: makeComparator
};

var Sort = {
  RelativeToUrlWithOutdatedSmartcutsLast: RelativeToUrlWithOutdatedSmartcutsLast
};

var LoadedSmartcut = {
  InstalledSmartcut: InstalledSmartcut,
  SmartcutVisibility: SmartcutVisibility,
  Smartcut: Smartcut,
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  minify: minify$2,
  rehydrate: rehydrate,
  getStartingUrl: getStartingUrl,
  getStartingUrlExn: getStartingUrlExn,
  getNumParams: getNumParams,
  updateScreenshot: updateScreenshot,
  startingAndRedirectedFromUrlPatterns: startingAndRedirectedFromUrlPatterns,
  doesMatchUrl: doesMatchUrl,
  determineRunFromPageCapability: determineRunFromPageCapability,
  Sort: Sort
};

function t_encode$6(v) {
  return Js_dict.fromArray([
              [
                "localId",
                Decco.stringToJson(v.localId)
              ],
              [
                "dbId",
                Decco.optionToJson(Decco.stringToJson, v.dbId)
              ],
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "description",
                Decco.optionToJson(Decco.stringToJson, v.description)
              ],
              [
                "startingUrlPattern",
                Decco.optionToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v.startingUrlPattern)
              ],
              [
                "maybeRedirectedFromUrlPatterns",
                Decco.optionToJson((function (param) {
                        return Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, param);
                      }), v.maybeRedirectedFromUrlPatterns)
              ],
              [
                "origins",
                Decco.arrayToJson(Decco.stringToJson, v.origins)
              ],
              [
                "recordingCommandLog",
                CommandLog$SmartcutsMacros.GlobalForRecordingResolved.t_encode(v.recordingCommandLog)
              ],
              [
                "authoringCommandLog",
                CommandLog$SmartcutsMacros.GlobalForAuthoring.t_encode(v.authoringCommandLog)
              ],
              [
                "commandLog",
                CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode(v.commandLog)
              ],
              [
                "smartcutParams",
                Decco.arrayToJson(t_encode, v.smartcutParams)
              ],
              [
                "recordingStartedAt",
                Decco.floatToJson(v.recordingStartedAt)
              ],
              [
                "recordingEndedAt",
                Decco.floatToJson(v.recordingEndedAt)
              ]
            ]);
}

function t_decode$6(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var localId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "localId"), null));
  if (localId.TAG === /* Ok */0) {
    var dbId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dbId"), null));
    if (dbId.TAG === /* Ok */0) {
      var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
      if (name.TAG === /* Ok */0) {
        var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
        if (description.TAG === /* Ok */0) {
          var startingUrlPattern = Decco.optionFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "startingUrlPattern"), null));
          if (startingUrlPattern.TAG === /* Ok */0) {
            var maybeRedirectedFromUrlPatterns = Decco.optionFromJson((function (param) {
                    return Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, param);
                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeRedirectedFromUrlPatterns"), null));
            if (maybeRedirectedFromUrlPatterns.TAG === /* Ok */0) {
              var origins = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "origins"), null));
              if (origins.TAG === /* Ok */0) {
                var recordingCommandLog = CommandLog$SmartcutsMacros.GlobalForRecordingResolved.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingCommandLog"), null));
                if (recordingCommandLog.TAG === /* Ok */0) {
                  var authoringCommandLog = CommandLog$SmartcutsMacros.GlobalForAuthoring.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "authoringCommandLog"), null));
                  if (authoringCommandLog.TAG === /* Ok */0) {
                    var commandLog = CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLog"), null));
                    if (commandLog.TAG === /* Ok */0) {
                      var smartcutParams = Decco.arrayFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutParams"), null));
                      if (smartcutParams.TAG === /* Ok */0) {
                        var recordingStartedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingStartedAt"), null));
                        if (recordingStartedAt.TAG === /* Ok */0) {
                          var recordingEndedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "recordingEndedAt"), null));
                          if (recordingEndedAt.TAG === /* Ok */0) {
                            return {
                                    TAG: /* Ok */0,
                                    _0: {
                                      localId: localId._0,
                                      dbId: dbId._0,
                                      name: name._0,
                                      description: description._0,
                                      startingUrlPattern: startingUrlPattern._0,
                                      maybeRedirectedFromUrlPatterns: maybeRedirectedFromUrlPatterns._0,
                                      origins: origins._0,
                                      recordingCommandLog: recordingCommandLog._0,
                                      authoringCommandLog: authoringCommandLog._0,
                                      commandLog: commandLog._0,
                                      smartcutParams: smartcutParams._0,
                                      recordingStartedAt: recordingStartedAt._0,
                                      recordingEndedAt: recordingEndedAt._0
                                    }
                                  };
                          }
                          var e = recordingEndedAt._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".recordingEndedAt" + e.path,
                                    message: e.message,
                                    value: e.value
                                  }
                                };
                        }
                        var e$1 = recordingStartedAt._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".recordingStartedAt" + e$1.path,
                                  message: e$1.message,
                                  value: e$1.value
                                }
                              };
                      }
                      var e$2 = smartcutParams._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".smartcutParams" + e$2.path,
                                message: e$2.message,
                                value: e$2.value
                              }
                            };
                    }
                    var e$3 = commandLog._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".commandLog" + e$3.path,
                              message: e$3.message,
                              value: e$3.value
                            }
                          };
                  }
                  var e$4 = authoringCommandLog._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".authoringCommandLog" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                          }
                        };
                }
                var e$5 = recordingCommandLog._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".recordingCommandLog" + e$5.path,
                          message: e$5.message,
                          value: e$5.value
                        }
                      };
              }
              var e$6 = origins._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".origins" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                      }
                    };
            }
            var e$7 = maybeRedirectedFromUrlPatterns._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".maybeRedirectedFromUrlPatterns" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = startingUrlPattern._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".startingUrlPattern" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
        }
        var e$9 = description._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".description" + e$9.path,
                  message: e$9.message,
                  value: e$9.value
                }
              };
      }
      var e$10 = name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".name" + e$10.path,
                message: e$10.message,
                value: e$10.value
              }
            };
    }
    var e$11 = dbId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dbId" + e$11.path,
              message: e$11.message,
              value: e$11.value
            }
          };
  }
  var e$12 = localId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".localId" + e$12.path,
            message: e$12.message,
            value: e$12.value
          }
        };
}

function toSavedSmartcut(id, param) {
  return {
          id: id,
          name: param.name,
          description: param.description,
          startingUrlPattern: param.startingUrlPattern,
          maybeRedirectedFromUrlPatterns: param.maybeRedirectedFromUrlPatterns,
          origins: param.origins,
          recordingCommandLog: param.recordingCommandLog,
          authoringCommandLog: param.authoringCommandLog,
          commandLog: param.commandLog,
          smartcutParams: param.smartcutParams
        };
}

function calcSize(unit, smartcut) {
  Curry._2(Log$SmartcutsMacros.faunaSize.log2, "recordingCommandLog size=", Belt_List.map(smartcut.recordingCommandLog, (function (param) {
              return Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.calcSize(unit, param);
            })));
  Curry._2(Log$SmartcutsMacros.faunaSize.log2, "authoringCommandLog size=", Belt_List.map(smartcut.authoringCommandLog, (function (param) {
              return Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.calcSize(unit, param);
            })));
  Curry._2(Log$SmartcutsMacros.faunaSize.log2, "commandLog size=", Belt_List.map(smartcut.commandLog, (function (param) {
              return Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.calcSize(unit, param);
            })));
  return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(t_encode$6(smartcut)));
}

function minify$3(smartcut) {
  return {
          localId: smartcut.localId,
          dbId: smartcut.dbId,
          name: smartcut.name,
          description: smartcut.description,
          startingUrlPattern: smartcut.startingUrlPattern,
          maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
          origins: smartcut.origins,
          recordingCommandLog: CommandLog$SmartcutsMacros.GlobalForRecordingResolved.minify(smartcut.recordingCommandLog),
          authoringCommandLog: CommandLog$SmartcutsMacros.GlobalForAuthoring.minify(smartcut.authoringCommandLog),
          commandLog: CommandLog$SmartcutsMacros.GlobalForPlayback.minify(smartcut.commandLog),
          smartcutParams: smartcut.smartcutParams,
          recordingStartedAt: smartcut.recordingStartedAt,
          recordingEndedAt: smartcut.recordingEndedAt
        };
}

function getImagesToSaveToCloud(param) {
  return Belt_Array.keepMap(Belt_Array.reduce($$Array.of_list(param.commandLog), [], (function (imagesToSave, param) {
                    var match = param.contextGlobal;
                    return $$Array.append(imagesToSave, [
                                match.screenshot,
                                match.croppedScreenshot
                              ]);
                  })), (function (screenshot) {
                if (typeof screenshot === "number" || screenshot.TAG !== /* Image */0) {
                  return ;
                } else {
                  return {
                          id: screenshot._0,
                          image: screenshot._1
                        };
                }
              }));
}

function startSavingScreenshotsToCloud(recordedSmartcutId, singleQuerySccessCallbackOpt, imagesToSave) {
  var singleQuerySccessCallback = singleQuerySccessCallbackOpt !== undefined ? singleQuerySccessCallbackOpt : (function (param, param$1) {
        
      });
  return PromiseUtils$SmartcutsMacros.doAllWithProgressUpdate((function (nSaved) {
                  return Curry._2(singleQuerySccessCallback, nSaved, imagesToSave.length);
                }), $$Array.map((function (param) {
                      var match = param.image;
                      var data = match.data;
                      var screenshotId = param.id;
                      var folder = Screenshot$SmartcutsMacros.deriveFolderName(recordedSmartcutId);
                      var fileName = Screenshot$SmartcutsMacros.deriveFileName(screenshotId, match.format);
                      var match$1 = PromiseUtils$SmartcutsMacros.withRetries(3, (function (param, param$1) {
                              if (data.TAG === /* Base64Encoded */0) {
                                return ImageKit$SmartcutsMacros.uploadWithBase64({
                                            file: data._0,
                                            fileName: fileName,
                                            folder: folder
                                          }, ImageKit$SmartcutsMacros.client);
                              } else {
                                return ImageKit$SmartcutsMacros.uploadWithBlob({
                                            file: data._0,
                                            fileName: fileName,
                                            folder: folder
                                          }, ImageKit$SmartcutsMacros.client);
                              }
                            }), (function (param) {
                              return true;
                            }), undefined, undefined);
                      return Curry._1(match$1[0], undefined).then(function (res) {
                                    Curry._2(Log$SmartcutsMacros.imageKit.warn2, "RESULT", res);
                                    return Promise.resolve([
                                                screenshotId,
                                                res
                                              ]);
                                  }).catch(function (jsPromiseError) {
                                  Curry._1(Log$SmartcutsMacros.imageKit.error1, Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.stringify, jsPromiseError));
                                  return Promise.resolve(undefined);
                                });
                    }), imagesToSave)).then(function (idResultPairs) {
              return Promise.resolve(Belt_MapString.fromArray(Belt_Array.keepMap(idResultPairs, (function (maybeIdAndResult) {
                                    return Belt_Option.map(maybeIdAndResult, (function (param) {
                                                  return [
                                                          Image$SmartcutsMacros.idAsString(param[0]),
                                                          param[1]
                                                        ];
                                                }));
                                  }))));
            });
}

function updateScreenshot$1(f, smartcut) {
  return {
          localId: smartcut.localId,
          dbId: smartcut.dbId,
          name: smartcut.name,
          description: smartcut.description,
          startingUrlPattern: smartcut.startingUrlPattern,
          maybeRedirectedFromUrlPatterns: smartcut.maybeRedirectedFromUrlPatterns,
          origins: smartcut.origins,
          recordingCommandLog: List.map((function (commandWithContextGlobal) {
                  var contextGlobal = commandWithContextGlobal.contextGlobal;
                  return {
                          id: commandWithContextGlobal.id,
                          command: commandWithContextGlobal.command,
                          contextGlobal: {
                            windowRef: contextGlobal.windowRef,
                            tabRef: contextGlobal.tabRef,
                            url: contextGlobal.url,
                            focusStatus: contextGlobal.focusStatus,
                            title: contextGlobal.title,
                            frame: contextGlobal.frame,
                            windowGeometry: contextGlobal.windowGeometry,
                            targetBoundingRect: contextGlobal.targetBoundingRect,
                            timestamp: contextGlobal.timestamp,
                            htmlSnapshot: contextGlobal.htmlSnapshot,
                            screenshot: Curry._1(f, contextGlobal.screenshot),
                            croppedScreenshot: Curry._1(f, contextGlobal.croppedScreenshot),
                            preconditions: contextGlobal.preconditions,
                            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                          }
                        };
                }), smartcut.recordingCommandLog),
          authoringCommandLog: List.map((function (commandWithContextGlobal) {
                  var contextGlobal = commandWithContextGlobal.contextGlobal;
                  return {
                          id: commandWithContextGlobal.id,
                          command: commandWithContextGlobal.command,
                          contextGlobal: {
                            windowRef: contextGlobal.windowRef,
                            tabRef: contextGlobal.tabRef,
                            url: contextGlobal.url,
                            focusStatus: contextGlobal.focusStatus,
                            title: contextGlobal.title,
                            frame: contextGlobal.frame,
                            windowGeometry: contextGlobal.windowGeometry,
                            targetBoundingRect: contextGlobal.targetBoundingRect,
                            timestamp: contextGlobal.timestamp,
                            htmlSnapshot: contextGlobal.htmlSnapshot,
                            screenshot: Curry._1(f, contextGlobal.screenshot),
                            croppedScreenshot: Curry._1(f, contextGlobal.croppedScreenshot),
                            preconditions: contextGlobal.preconditions,
                            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                          }
                        };
                }), smartcut.authoringCommandLog),
          commandLog: List.map((function (commandWithContextGlobal) {
                  var contextGlobal = commandWithContextGlobal.contextGlobal;
                  return {
                          id: commandWithContextGlobal.id,
                          command: commandWithContextGlobal.command,
                          contextGlobal: {
                            windowRef: contextGlobal.windowRef,
                            tabRef: contextGlobal.tabRef,
                            url: contextGlobal.url,
                            focusStatus: contextGlobal.focusStatus,
                            title: contextGlobal.title,
                            frame: contextGlobal.frame,
                            windowGeometry: contextGlobal.windowGeometry,
                            targetBoundingRect: contextGlobal.targetBoundingRect,
                            timestamp: contextGlobal.timestamp,
                            htmlSnapshot: contextGlobal.htmlSnapshot,
                            screenshot: Curry._1(f, contextGlobal.screenshot),
                            croppedScreenshot: Curry._1(f, contextGlobal.croppedScreenshot),
                            preconditions: contextGlobal.preconditions,
                            maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                          }
                        };
                }), smartcut.commandLog),
          smartcutParams: smartcut.smartcutParams,
          recordingStartedAt: smartcut.recordingStartedAt,
          recordingEndedAt: smartcut.recordingEndedAt
        };
}

exports.ParamDescriptor = ParamDescriptor;
exports.ForAuthoringSubmission = ForAuthoringSubmission;
exports.SavedSmartcut = SavedSmartcut;
exports.LoadedSmartcut = LoadedSmartcut;
exports.t_encode = t_encode$6;
exports.t_decode = t_decode$6;
exports.toSavedSmartcut = toSavedSmartcut;
exports.calcSize = calcSize;
exports.minify = minify$3;
exports.getImagesToSaveToCloud = getImagesToSaveToCloud;
exports.startSavingScreenshotsToCloud = startSavingScreenshotsToCloud;
exports.updateScreenshot = updateScreenshot$1;
/* Log-SmartcutsMacros Not a pure module */
